module.exports = __webpack_public_path__ + "static/media/forbes.57ea6cd0.jpg";